<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { box-sizing: border-box; }
html, body, #app { height: 100%; margin: 0; padding: 0; }
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  background: #f0f2f5;
}

/* 统一后台列表的卡片、表头与分隔线，减少默认表格的网格感。 */
.admin-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #edf0f3;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(31, 45, 61, 0.04);
}
.admin-toolbar > * { margin: 0; }
.admin-toolbar .filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.admin-toolbar .el-button + .el-button { margin-left: 0; }

.admin-table {
  overflow: hidden;
  border: 1px solid #edf0f3 !important;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(31, 45, 61, 0.04);
}
.admin-table::before { display: none; }
.admin-table.el-table--border::after,
.admin-table.el-table--group::after { display: none; }
.admin-table th.el-table__cell {
  height: 50px;
  padding: 0;
  color: #52606d;
  font-size: 13px;
  font-weight: 600;
  background: #f7f9fb;
  border-bottom: 1px solid #edf0f3;
}
.admin-table td.el-table__cell {
  height: 58px;
  padding: 8px 0;
  color: #364152;
  border-bottom: 1px solid #f0f2f5;
}
.admin-table th.el-table__cell > .cell,
.admin-table td.el-table__cell > .cell { line-height: 1.5; }
.admin-table .el-table__body tr:hover > td.el-table__cell {
  background: #f5f9ff !important;
}
.admin-table .el-table__fixed,
.admin-table .el-table__fixed-right {
  box-shadow: 0 0 14px rgba(31, 45, 61, 0.08);
}
.admin-table .el-table__fixed-right::before { display: none; }
.admin-table .el-button--text { font-weight: 500; }
.admin-table .el-tag {
  border-radius: 999px;
  padding: 0 9px;
}
.admin-table .el-table__empty-block { min-height: 120px; }
.admin-table .el-table__empty-text { color: #9aa5b1; }

.admin-pagination {
  margin-top: 18px;
  padding: 12px 2px 0;
}
.admin-pagination .el-pager li,
.admin-pagination button {
  border-radius: 8px;
}

@media (max-width: 768px) {
  .admin-toolbar { align-items: stretch; flex-direction: column; }
  .admin-toolbar .filters { width: 100%; }
  .admin-toolbar .el-input,
  .admin-toolbar .el-select { max-width: 100%; }
}
</style>
